module.exports = __webpack_public_path__ + "img/blog-news.f28f372b.png";